var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-cell",class:{
    'is-anchor': _vm.isAnchor,
    'is-path': _vm.hasPath,
    'is-blocked': _vm.isBlocked,
  },attrs:{"data-positionx":_vm.cell.positionx,"data-positiony":_vm.cell.positiony}},[(_vm.isAnchor)?_c('shape-icon',{attrs:{"shape":_vm.cell.shape,"color":_vm.cell.color,"value":_vm.cell.value,"filled":_vm.cell.filled,"size":_vm.iconSize,"settings":_vm.settings}}):(_vm.hasPath)?_c('shape-path',{attrs:{"direction":_vm.cell.direction,"color":_vm.activeColor,"pathWeight":_vm.settings.pathWeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }